console.log ( '%c /init/init-account.component.ts CONSTRUCTOR', 'color:white;background-color:gray;' );

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Validators, FormControl } from '@angular/forms';
import { flatMap, map } from 'rxjs/operators';
import { BaseComponent } from '../commons/BaseComponent';
import { AppService } from '../commons/app.service';
import { XsApplicationEventsService } from '../xs/services/events/application-events.service';

@Component({
  selector: 'admin-init-account',
  templateUrl: './init-account.component.html'
})
export class InitAccountComponent extends BaseComponent implements OnInit {

  status:number
  message:string


  passControl = new FormControl('', [Validators.required, Validators.minLength(5)]);
  emailControl = new FormControl('', [Validators.required, Validators.email]);
  nameControl = new FormControl('', [Validators.required]);
  accNameControl = new FormControl('', [Validators.required]);

  constructor(public service:AppService, private route: ActivatedRoute, public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog, applicationEvents:XsApplicationEventsService) {
    super(router, snackBar, dialog);
    console.log ( '%c /init/init-account.component.ts', 'color:white;background-color:black;' );
  }

  ngOnInit() {

    console.log ( '%c /init/init-account.component.ts : onInit()', 'color:white;background-color:black;' );
    this.route.queryParams.subscribe(params => {
      //console.log("ENETR initComponent params: ",params)
      this.status = params["status"]
      this.message = params["msg"]
    })

  }

  createUserAccount() {
    console.log ( '%c /init/init-account.component.ts : createUserAccount()', 'color:white;background-color:black;' );
    let args = {
      name:this.nameControl.value,
      email:this.emailControl.value,
      password:this.passControl.value,
      accountName:this.accNameControl.value,
    }
    this.loading = true
    this.service.V.api('/access/registerCAN','post', args)
      .pipe(
        flatMap(res => this.service.V.loginWithUsernameObservable(args.email, args.password) ),
        flatMap(res => this.service.refreshMe()),
        flatMap(res => this.service.refreshData())
      ).subscribe(
        res => {
          this.router.navigate(['app'], {queryParams:{setup: true} })
          this.loading = false
        }, err => {
          this.loading = false
          this.openSnackBarError(err.message)
        }
      )
  }
  
}
